import styles from '../player.module.scss';
import Icona from 'components/3cat/ui/Icona';
import CodiEspectador from 'components/3cat/CodiEspectador';
import __isEmpty from 'lodash/isEmpty';

export default function FullScreen(props) {
    const { titol, nomProg, textAud, changeAudioDesc, aud, edat } = props;

    return (
        <div className={styles.fullscreenrow}>
            <div className={styles.nom}>{nomProg}</div>
            <div className={styles.titol}>{titol}</div>
            <div className={styles.subinfo}>
                {/* //ELIMINAR I DESCOMENTAR CODIS ÈTICS TP */}
                {edat !== 'CE_TP' && !__isEmpty(edat) && (
                    //{!__isEmpty(edat) && (
                    <span className={styles.edat}>
                        <CodiEspectador key={edat} codi={edat} mida='20' />
                    </span>
                )}
                {aud && (
                    <button className={styles.boto} aria-label='audiodescripció' onClick={changeAudioDesc}>
                        <div className={styles.boto_text}>{textAud}</div>
                        <Icona estil='clickable' alt='Icona audiodescripció' icona='audiodescripcio' />
                    </button>
                )}
            </div>
        </div>
    );
}
